import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  TableContainer,
  useColorModeValue
} from '@chakra-ui/react'
import { FC } from 'react'

// Define the shape of each item in dataDefault
interface DataDefault {
  curva?: string
  default?: string
  min?: string
  max?: string
}

// Define the props for the component
interface ParametrosTableProps {
  dataDefault: DataDefault[]
}

const ParametrosTable: FC<ParametrosTableProps> = ({ dataDefault }) => {
  return (
    <Box
      shadow={'xl'}
      border={'1px solid'}
      borderColor={useColorModeValue('gray.800', 'gray.500')}
      rounded={'lg'}
      w="100%"
      h="100%"
    >
      <Box
        bg="#1d5840"
        color="white"
        width="100%"
        textAlign="center"
        py={2}
        roundedTop="lg"
      >
        <Box fontWeight="700" fontSize="xl" isTruncated>
          Parametros Default
        </Box>
      </Box>
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th px={2} py={1} fontSize="16px">
                Curva
              </Th>
              <Th px={2} py={1} fontSize="16px">
                Default
              </Th>
              <Th px={2} py={1} fontSize="16px">
                Min
              </Th>
              <Th px={2} py={1} fontSize="16px">
                Max
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {dataDefault.map((item, index) => (
              <Tr key={index}>
                <Td px={4} py={2} fontSize="18px">
                  {item.curva}
                </Td>{' '}
                {/* Ajuste conforme necessário */}
                <Td px={4} py={2}>
                  {item?.default ?? ''}
                </Td>
                <Td px={4} py={2}>
                  {item?.min ?? ''}
                </Td>
                <Td px={4} py={2}>
                  {item?.max ?? ''}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default ParametrosTable
